import { KatButton, KatModal } from '@amzn/katal-react';
import React, { useContext, useRef, useState } from 'react';
import styled from 'styled-components';
import { ViewPanel } from './ViewPanel';
import { RJSFSchema, UiSchema } from '@rjsf/utils';
import { ElementHeading } from './ElementHeading';
import { CaseSummaryConstants } from 'src/constants/ProjectConstants';
import Spacer from 'src/components/Layout/Spacer';
import { logger } from 'src/logger';
import { TranslationContext } from 'src/state/providers/TranslationProvider';

const MultiElementContainerLayout = styled.div`
  :hover {
    background: ${({ theme }) => theme.colors.Zircon};
  }
`;
export interface IMultiElementContainer {
  coreSchema: RJSFSchema;
  uiSchema: UiSchema;
  defaultFormData: any;
  formTitle: string;
  onUpdate: (data: any) => void;
}

const MultiElementContainer: React.FC<IMultiElementContainer> = ({
  coreSchema,
  uiSchema,
  defaultFormData,
  formTitle,
  onUpdate,
}) => {
  const [show, setShow] = useState(false);
  const child = useRef<any>();

  const onSubmit = (data: any) => {
    onUpdate && onUpdate(data);
    setShow(false);
  };
  const { caseSummaryBundle, commonBundle } = useContext(TranslationContext);

  return (
    <MultiElementContainerLayout data-testid="MultiElementContainerLayout">
      <ElementHeading
        header={caseSummaryBundle.getMessage(
          CaseSummaryConstants.CASE_OVERVIEW_HEADING,
        )}
        onEditClick={setShow}
      />
      <Spacer height="0.5rem" />
      <ViewPanel
        data-testid="StaticViewPanel"
        coreSchema={coreSchema}
        uiSchema={uiSchema}
        disabled={true}
        formState={defaultFormData}
      />
      <KatModal
        data-testid="ViewPanelKatModal"
        visible={show}
        title={formTitle}
        scrollAll
        onClose={() => setShow(false)}
        footer={
          <KatButton
            label={commonBundle.getMessage(
              CaseSummaryConstants.SAVE_BUTTON_TEXT,
            )}
            variant="primary"
            onClick={() => {
              //call the onSubmit action of ReactJson Form.
              if (child.current) {
                child.current.formSubmit();
                logger.info('Invoking FormSubmit for Case Summary Panel.');
              }
            }}
          />
        }
      >
        <ViewPanel
          data-testid="ViewPanelOnModal"
          coreSchema={coreSchema}
          uiSchema={uiSchema}
          ref={child}
          disabled={false}
          formState={defaultFormData}
          onSubmit={onSubmit}
        />
      </KatModal>
    </MultiElementContainerLayout>
  );
};

export { MultiElementContainer };
